export default "__VITE_ASSET__BCCh3$hA__$_?url__"